export default {
  actions: {
    actionProgressBarStatus: (context, bool = false) => context.commit('mutationProgressBarStatus', bool),
  },
  mutations: {
    mutationProgressBarStatus: (state, bool) => state.progress_bar_status = bool,
  },
  state: {
    progress_bar_status: true,
  },
  getters: {
    getProgressBarStatus: state => state.progress_bar_status,
  }
}
